import type { ComposedLayerData, LayerCounts } from './map-state'

export interface LayerState extends LayerCounts {
  generation: number
}

export function createLayerStateTracker(): {
  get: () => LayerState
  apply: (composed: ComposedLayerData) => LayerState
} {
  let state: LayerState = {
    segmentFeatures: 0,
    takeoverFeatures: 0,
    undrivenFeatures: 0,
    generation: 0,
  }

  return {
    get: () => ({ ...state }),
    apply(composed) {
      state = {
        ...composed.counts,
        generation: state.generation + 1,
      }
      return { ...state }
    },
  }
}